import React from 'react'
import { Footer, Logo, ClassificationLabel, LevelAccess } from "@mds/merck-design-system-dev";
function MyFooter() {
  const currentYear = new Date().getFullYear();
  return (
   
    <Footer
    theme="light"
    bottomStripe={{
        logo: <Logo logo='msd' theme='light' />,
        copyright: `Copyright © ${currentYear} Merck & Co., Inc., Rahway, NJ USA, and its affiliates. All rights reserved. | This site is intended only for residents of the United States and Canada.`,
        slots: [<LevelAccess />, <ClassificationLabel type='lightProprietary' />]
    }}
/>
  )
}

export default MyFooter